// Styles
import styles from './Separation.module.sass'

interface SeparationProps {
  marginBlock?: number
  vertical?: boolean
  hexColor?: string
}

const Separation = ({
  marginBlock = 0,
  vertical,
  hexColor = '#CCC'
}: SeparationProps) => {
  return (
    <div
      style={{
        borderTop: `${!vertical && '.1rem solid ' + hexColor}`,
        borderLeftColor: `${vertical && hexColor}`,
        marginBlock: `${marginBlock}px`
      }}
      className={`${styles.line} ${vertical ? styles.vertical : ''}`}
    />
  )
}

export default Separation
